

























































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { post, get } from '@/fn/ajax'
import { resourceItem } from '@/api/res'
declare var PhotoSphereViewer: any
@Component
export default class PlayItem extends ViewBase {
  @Prop({ default: 0 }) id!: any
  @Prop({ default: {} }) chapter!: any
  @Prop({ default: 'Play' }) playStatus!: string

  item: any = {}

  lang: any = {}

  imgurl = ''

  refreshTimer: any = null

  viewer: any = {}

  isBofang: boolean = false

  is360Bofang: boolean = false

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  get isPanoramaImage() {
    const item = this.item
    return item.file_type == 'image' && item.is_bokong == 1
  }
  get isPanoramaVideo() {
    const item = this.item
    return item.file_type == 'video' && item.is_bokong == 1
  }
  get isVRVideo() {
    const item = this.item
    return (item.file_type == 'video' && item.is_bokong == 0) || item.file_type == 'app'
  }

  get isPlaying() {
    if (!this.isVRVideo) {
      return false
    }
    const refPlayer: any = this.$refs.refPlayer
    return this.isVRVideo && !refPlayer.paused
  }
  beforeDestroy() {
    if (this.viewer && this.item.file_type == 'video' && this.item.is_bokong == 1) {
      this.viewer.stop()
      this.viewer.destroy()
      localStorage.video_gettime = 0
    } else if (
      this.viewer &&
      this.item.file_type == 'image' &&
      this.item.is_bokong == 1
    ) {
      this.viewer.destroy()
    }
    clearInterval(this.refreshTimer)
  }
  created() {
    this.viewer = null
    this.lang = this.i18n.vResItem
    const lang: any = this.lang
    this.fetch()
    this.$navigation.on('forward', (to: any, from: any) => {
      if (from.route.name != 'resourceDetail') {
        return
      }
      if (this.viewer && this.viewer.video) {
        // 关闭正在播放的视频
        this.viewer.stop()
      }
    })
  }
  torant(x: any) {
    return (x * 180) / Math.PI
  }
  topi(x: any) {
    return (x * Math.PI) / 180
  }
  topick(longitude: any, latitude: any) {
    if (longitude && latitude) {
      longitude = this.torant(longitude)
      latitude = this.torant(latitude)
    }

    // 	  ids	是	数组	设备id
    // lat	是	double	维度
    // lnt	是	double	经度
    const pdata = {
      ids: this.$store.state.selectedDeviceIds,
      lat: latitude,
      lng: longitude
    }
    post('/api/play/set_eye_coordinate', pdata)
      .then(() => {})
      .catch(({ msg }) => {})
  }
  panoramaMarke() {
    const viewer = this.viewer
    const _this = this
    viewer.on('click', (e: any) => {
      viewer.addMarker({
        id: 'my',
        tooltip: '',
        longitude: e.longitude,
        latitude: e.latitude,
        image: '/lib/photo/assets/pin1.png',
        width: 32,
        height: 32,
        anchor: 'bottom center',
        data: {
          deletable: true
        }
      })
      _this.topick(e.longitude, e.latitude)
    })
    viewer.on('select-marker', (marker: any, dblclick: any) => {
      if (marker.data && marker.data.deletable && marker.id == 'my') {
        if (dblclick) {
          viewer.removeMarker(marker)
          this.topick('', '')
        } else {
          // console.log(marker)
          viewer.updateMarker({
            id: marker.id,
            image: '/lib/photo/assets/pin2.png'
          })
        }
      }
    })
    this.refreshTimer = setInterval(() => {
      const url = '/api/play/get_eye_coordinates?class_id=' + localStorage.classId || ''
      get(url).then(res => {
        const resourceLists = res.data.list
        if (this.viewer && this.viewer.clearMarkers) {
          this.viewer.clearMarkers()
        }
        updateEye(resourceLists)
      })
    }, 3000)
    const updateEye = (params: any) => {
      const listaddMarker: any = []
      const listupdateMarker: any = []
      params.forEach((item: any, i: any) => {
        if (!viewer.hud.markers[item.client_id]) {
          const listt = {
            id: item.client_id,
            tooltip: {
              content: item.name + '',
              position: 'top'
            },
            longitude: this.topi(item.longitude),
            latitude: this.topi(item.latitude),
            image: '/lib/photo/assets/grl2.png',
            width: 32,
            height: 28,
            anchor: 'bottom center',
            data: {
              deletable: true
            }
          }
          listaddMarker.push(listt)
        } else {
          const listt2 = {
            id: item.client_id,
            longitude: this.topi(item.longitude),
            latitude: this.topi(item.latitude)
          }
          // console.log(listt2)
          listupdateMarker.push(listt2)
        }
      })
      // console.log("listupdateMarker",listupdateMarker)
      // 获取标记点 更新
      // console.log("listaddMarker",listaddMarker)
      if (listaddMarker.length > 0) {
        // console.log(listaddMarker)
        viewer.addMarker(listaddMarker)
      }

      if (listupdateMarker.length > 0) {
        viewer.updateMarker(listupdateMarker)
      }
    }
  }

  async fetch() {
    const query: any = {
      id: this.id
    }
    try {
      const { data } = await resourceItem(query)
      this.item = data.item
      this.$emit('play-item', this.item)
      this.imgurl = data.banner
      this.$emit('is-review', data.review)
      this.$nextTick(() => {
        if (this.isPanoramaImage) {
          this.initPanoramaImage()
        }
        if (this.isPanoramaVideo) {
          this.isBofang = true
          this.initPanoramaVideo()
        }
        // 视频
        // if (this.isVRVideo) {
        //   this.isBofang = true
        //   const refPlayer: any = this.$refs.refPlayer
        //   const that = this
        //   refPlayer.addEventListener('play', () => {
        //     that.isBofang = false
        //   })
        //   refPlayer.addEventListener('pause', () => {
        //     that.isBofang = true
        //   })
        // }
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  initPanoramaImage() {
    const player: any = this.$refs.refPlayerImg
    const that = this
    if (player != null && this.isPanoramaImage) {
      player.innerHTML = ' '
      this.viewer = new PhotoSphereViewer({
        container: player,
        panorama: that.item.image_url,
        // loading_img: '/lib/photo/assets/photosphere-logo.gif',
        loading_load: true,
        time_anim: false,
        navbar: ['zoom', 'markers']
      })
    }
  }
  initPanoramaVideo() {
    const that = this
    const volume = false
    const videoPlayer: any = this.$refs.refVideoPlayer
    if (videoPlayer != null && this.isPanoramaVideo) {
      videoPlayer.innerHTML = ' '
      this.viewer = new PhotoSphereViewer.Video({
        container: videoPlayer,
        video: [
          { source: that.item.video_url, resolution: 'HD' },
          { source: that.item.video_url, resolution: 'SD' }
        ],
        default_resolution: 'SD',
        muted: false,
        caption: 'openid.tiele',
        // loading_img: '/lib/photo/assets/photosphere-logo.gif',
        loading_load: true,
        navbar: ['duration', 'volume', 'markers', 'fullscreen']
      })

      if (this.viewer) {
        this.is360Bofang = true
      }

      this.viewer.video.addEventListener('play', () => {
        that.is360Bofang = false
      })
      this.viewer.video.addEventListener('pause', () => {
        that.is360Bofang = true
      })
    }
    this.viewer.video.addEventListener('play', () => {
      that.isBofang = false
    })
    this.viewer.video.addEventListener('pause', () => {
      that.isBofang = true
    })
  }
  play360Video() {
    if (this.viewer) {
      if (this.is360Bofang == true) {
        if (this.viewer.video) {
          this.viewer.play()
        }
      }
    }
  }
  playVideo() {
    const refPlayer: any = this.$refs.refPlayer
    refPlayer.play()
    this.isBofang = false
  }

  playVRVideo() {
    this.viewer.play()
    this.isBofang = false
  }

  setViewer() {
    const viewer = this.viewer
    const playStatus = this.playStatus

    // Play 处于停止播放状态

    // PauseNew 处于暂停播放状态
    if (
      playStatus != 'Play' &&
      playStatus != 'PauseNew' &&
      playStatus != 'Pause' &&
      viewer
    ) {
      this.panoramaMarke()
    } else {
      if (viewer && this.isPanoramaImage) {
        clearInterval(this.refreshTimer)
        viewer.on('click', (e: any) => {
          if (viewer && viewer.clearMarkers) {
            viewer.clearMarkers()
          }

          return false
        })
        if (viewer && viewer.clearMarkers) {
          viewer.clearMarkers()
        }

        setTimeout(() => {
          if (viewer && viewer.clearMarkers) {
            viewer.clearMarkers()
          }
        }, 1100)
      }
    }

    if (viewer) {
      if (playStatus == 'Play') {
        // 停止
        if (viewer.video) {
          viewer.stop()
          // 停止刷新视点
          clearInterval(this.refreshTimer)
          viewer.setTime(0)
        }
      }
      if (playStatus == 'Pause' || playStatus == 'Stop') {
        if (viewer.video) {
          viewer.play()
        }
      }
      if (playStatus == 'PauseNew') {
        // 暂停
        if (viewer.video) {
          // clearInterval(this.refreshTimer)
          viewer.stop()
        }
      }
    }
  }

  @Watch('id')
  watchId(id: any) {
    this.fetch()
  }

  @Watch('playStatus')
  watchPlayStatus() {
    this.setViewer()
  }

  @Watch('viewer')
  watchViewer() {
    this.setViewer()
  }
}
